const SURVEY_DISMISSED_KEY_PREFIX = "mf:dismissed:";

function getDismissedKey(formId: string) {
  return `${SURVEY_DISMISSED_KEY_PREFIX}${formId}`;
}

export function getIsSurveyDismissed(formId: string) {
  try {
    return sessionStorage.getItem(getDismissedKey(formId)) === "1";
  } catch {
    return false;
  }
}

export function markSurveyDismissed(formId: string) {
  try {
    sessionStorage.setItem(getDismissedKey(formId), "1");
  } catch {
    // sessionStorage unavailable (private mode, quota) — ignore
  }
}
